module.exports = __webpack_public_path__ + "static/media/NunitoSans_7pt-SemiBold.35d5db5e.ttf";